// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import RecommendedProductRequestFormState from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/RecommendedProductRequestFormState";
import { Draft } from "immer";

const initialState: RecommendedProductRequestFormState = {
    fieldValues: {},
};

const actions = {
    "Greif/Components/RecommendedProductRequestForm/ClearForm": (draft: Draft<RecommendedProductRequestFormState>) => {
        draft.fieldValues = {};
    },
    "Greif/Components/RecommendedProductRequestForm/SetFieldValue": (
        draft: Draft<RecommendedProductRequestFormState>,
        action: { key: string; value: string | any[] | undefined },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsRecommendedProductRequestFormActions = Parameters<typeof reducer>[1];
export default reducer;
